export default __webpack_public_path__ + "static/media/about1.9d140fee.jpg";